export default {
    '验号中心': {
        '旺旺权重标签评估': {
            url: '/ww-label-weight',
            tag: ['一键透视买家权重评分']
        },
        '淘宝排名查询': {
            url: '/keyRank',
            tag: ['指定关键词', '批量查询']
        },
        '旺旺照妖镜': {
            url: '/home',
            tag: ['实时标签', '安全评估', '打标类型']
        },
        '搜索权重推送': {
            url: '/weightpush',
            tag: ['推送商品到搜索首屏', '提高搜索权重']
        },
        '竞品数据透析': {
            url: '/monitor/competitive',
            tag: ['全面监控竞品', '解析竞品']
        },
        '大数据验号': {
            url: '/checkAccount',
            tag: ['旺旺信息', '标签查询']
        },
        '淘宝号标签查询': {
            url: '/tagSearch',
            tag: ['客观反应官方用户画像']
        },
        '无痕做单': {
            url: '/traceless',
            tag: ['提供转化率', '提高搜索词权重']
        },
        '指数换算': {
            url: '/transformData',
            tag: ['转化指数', '加购指数', '收藏人气']
        },
        '防P图验号': {
            url: '/validPicture',
            tag: ['查地址', '查性别', '查足迹', '查评价']
        },
        '淘宝客订单检测': {
            url: '/tbguest',
            tag: ['杜绝佣金丢失']
        },
        'DSR智能计算器': {
            url: '/checkNum/dsrCal',
            tag: ['自动计算', '一目了然', '精确性']
        },
        '淘口令生成': {
            url: '/taokouling',
            tag: ['无分享人的淘口令', '任意链接']
        },
        '宝贝评价分析': {
            url: '/appraise',
            tag: ['淘宝宝贝评价数据分析', '掌握同行评价数据']
        },
        'TOP20w词库': {
            url: '/lexicon',
            tag: ['指数高', '流量高', '转化率高']
        },
        '搜索下拉推荐词': {
            url: '/lexRecommend',
            tag: ['实时查询', '关联词', '下拉列表']
        },
        '旺旺搜索词推荐': {
            url: '/lexTaobaoTag',
            tag: ['淘宝推荐', '关键标签', '实时查询']
        },
        '抖音验号': {
            url: '/dy-check',
            tag: ['查标签', "数据分析", "查账号信息"]
        },
        '免费工具箱': {
            url: '/taokit',
            tag: ['免费电商工具']
        },
    },

    // '礼品发货': {
    //     '商品列表': {
    //         url: '/store/list',
    //         tag: ['查商品']
    //     },
    //     '订单列表': {
    //         url: '/store/orderList',
    //         tag: ['查订单']
    //     },
    //     '包裹列表': {
    //         url: '/store/package',
    //         tag: ['查包裹']
    //     },
    // },
    '卡首屏': {
        '关键词卡首屏': {
            url: '/checkNum/firstPause',
            tag: ['解决新品没流量', '补手淘关键词流量'],
            showCode: "checkNum_firstPause",
        },
        '找相似入口': {
            url: '/checkNum/similarImport',
            tag: ['多样化首选', '多流量来源'],
            showCode: "checkNum_similarImport",
        },
        '买家秀': {
            url: '/head_screen/buyers-show',
            tag: ['配合做单增加权重'],
            showCode: "head_screen_buyers-show",
        },
        '旺旺强行打标': {
            url: '/marking',
            tag: ['魔搜', '指定打标', '引流利器'],
            showCode: "marking",
        },
        '猜你喜欢': {
            url: '/tbmobile/guess',
            tag: ['个性化推荐', '快速流量来源'],
            showCode: "tbmobile_guess",
        },
        '微详情': {
            url: '/head_screen/micro-details',
            tag: ['卡微详情', '猜你喜欢入池'],
            showCode: "head_screen_micro-details",
        },
        '购后猜你喜欢': {
            url: '/head_screen/buy-ask-everyone',
            tag: ['猜你喜欢打标', '流量来源我的淘宝'],
            showCode: "head_screen_buy-ask-everyone",
        },
        '手淘其它商品详情页': {
            url: '/head_screen/other-shop',
            tag: ['竞品打标', '卡竞品流量'],
            showCode: "head_screen_other-shop",
        },
        '天天特卖卡首屏': {
            url: '/head_screen/daily-deals',
            tag: ['推荐猜你喜欢', '天天特卖流量来源'],
            showCode: "head_screen_daily-deals",
        },
        '抖音卡首屏': {
            url: '/dy-first-page',
            tag: ['快速卡榜单入口', '提高渠道入口权重'],
            showCode: "dy-first-page",
        },
        '抖音搜索卡首屏': {
            url: '/first-flow-dy/first-flow',
            tag: ['提高商品权重', '流量来源-[搜索]'],
            showCode: "first_flow_dy_first_flow",
        },
        '抖音猜你喜欢': {
            url: '/first-flow-dy/guess',
            tag: ['流量来源-[商城推荐流量]'],
            showCode: "first_flow_dy_guess",
        },
        '拼多多打标': {
            url: '/pddScreen',
            tag: ['多号推送', '商品标签打标'],
            showCode: "pddScreen",
        },
        '1688卡首屏': {
            url: '/first-flow-albb',
            tag: ['快速卡榜单入口', '提高渠道入口权重'],
            showCode: "head_screen_recommend",
        },
        '大家都说好': {
            url: '/first-flow-pdd/said-ok',
            tag: ['商品卡在首屏', '极大的提升权重'],
            showCode: "first_flow_pdd_said_ok",
        },
        '拼多多搜索卡首屏': {
            url: '/first-flow-pdd/first-flow',
            tag: ['提升关键词搜索权重'],
            showCode: "first_flow_pdd_first_flow",
        },
        '卡首屏系列': {
            url: '/head_screen/recommend',
            tag: ['解决无流量问题'],
            showCode: "head_screen_recommend",
        },
    },
    '手淘卡屏': {
        '有好货': {
            url: '/tbmobile/nicegoods',
            tag: ['手淘首页', '流量来源', '多流量来源']
        },
        '手淘推荐': {
            url: '/head_screen/recommend',
            tag: ['到手淘推荐的商品列表页', '提升商品路径访问权重']
        },
        '猜你喜欢': {
            url: '/tbmobile/guess',
            tag: ['个性化推荐', "快速流量来源"]
        },
        '每日好店': {
            url: '/tbmobile/dayshops',
            tag: ['首页位置', '流量大', '没有类目限制']
        },
        '亲宝贝': {
            url: '/tbmobile/probaby',
            tag: ['多流量来源', '多样化首选']
        },
        '首页钻展': {
            url: '/tbmobile/hbooth',
            tag: ['配合直通车推广', '流量大']
        },
        '全球购': {
            url: '/tbmobile/globalshop',
            tag: ['全球购板块', '类目限制']
        },
        '生活研究所': {
            url: '/head_screen/life',
            tag: ['解决无流量问题']
        },
        '淘抢购': {
            url: '/tbmobile/robshop',
            tag: ['快速获取手淘首页来源', '提高商品权重']
        },
        '淘金币': {
            url: '/head_screen/coins',
            tag: ['流量来源淘金币']
        },
        'iFshion': {
            url: '/tbmobile/iFashion',
            tag: ['潮流店铺', '流量大', '提升商品权重']
        },
        // 20240307
        '手淘直播': {
            url: '/tbmobile/tm-live',
            tag: ['配合直通车推广', '流量大']
        },
        // '潮玩城': {
        //     url: '/tbmobile/tideplay',
        //     tag: ['年轻人', '效果定位', '炫酷']
        // },
        // '极有家': {
        //     url: '/tbmobile/polehome',
        //     tag: ['家居', '运营助益', '软装']
        // },

        // '手淘清仓流量': {
        //     url: '/head_screen/clear',
        //     tag: ['解决无流量问题']
        // },
        // '手淘网红流量': {
        //     url: '/head_screen/netred',
        //     tag: ['解决无流量问题']
        // },
    },
    '竞品监控': {
        '单品详情': {
            url: '/monitor/detail',
            tag: ['竞品监控详情']
        },
        '竞品监控': {
            url: '/monitor/competitive',
            tag: ['全面监控竞品', '解析竞品']
        },
        '开通竞品监控': {
            url: '/monitor/annual-fee',
            tag: ['开通竞品监控入口']
        },
        '历史记录': {
            url: '/monitor/record',
            tag: ['竞品监控历史记录']
        },
    },
    '流量中心': {
        '淘宝流量提升': {
            url: '/flow/taobao',
            tag: ['淘宝', '数据提升', '流量资源']
        },
        '拼多多流量提升': {
            url: '/flow/pdd',
            tag: ['拼多多', '数据提升', '流量资源']
        },
        '京东流量提升': {
            url: '/flow/jd',
            tag: ['京东', '数据提升', '流量资源']
        },
        '任务列表': {
            url: '/flow/tasklist',
            tag: ['各平台发布任务查看', '精确定位']
        },
    }
}
